import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty, not } from 'ramda';
import { ROUTES } from '../router';

const withGuardHOC = (Component) => {

  return (props) => {

    const { location } = props;
    const { pathname } = location;
    const {
      documentType,
      documentNumber,
    } = useSelector(state => state.estimator);

    const documentsValidation = not(isEmpty(documentType) || isEmpty(documentNumber));

    switch (pathname) {
      case ROUTES.BENEFICIARIES_REGISTER:
        if ( not(documentsValidation) ) return <Redirect to={ROUTES.DOCUMENT_VERIFICATION} />
        return <Component { ...props } />
      case ROUTES.MINIMUM_PENSION_ESTIMATE:
        if ( not(documentsValidation) ) return <Redirect to={ROUTES.DOCUMENT_VERIFICATION} />
        return <Component { ...props } />;
      default:
        return <Redirect to={ROUTES.HOME} />
    }
  };
};

export default withGuardHOC;